import $ from 'jquery';
import {smoothy, Easings} from 'smoothy';

$('a.booking-bar').on('click', (ev) => {
    return; // The form is no longer visible in mobile view where the booking-bar is visible.
    const $quickBookingForm = $('.quick-booking').first();
    if ($quickBookingForm.length === 0) {
        return;
    }
    ev.preventDefault();
    smoothy(() => $quickBookingForm.offset().top - (60 + 45), 1000);
});
